import React, {useContext, useEffect, useState} from 'react';

// Material UI
import {Grid} from "@mui/material";

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";
import LineItemOptionList from "components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import WmsItemCodes from "components/WMS/Mobile/WmsItemList/components/WmsItemCodes";
import WmsItemPlaceList from "components/WMS/Mobile/WmsItemList/components/WmsItemPlaceList";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import VariationCount from "components/WMS/Mobile/WmsItemList/components/VariationCount";
import CustomButton from "../../../../../../components/CustomButton";
import {Card, CardContent} from "@mui/material";

// Contexts
import {WMSContext} from "views/wms/context/WMSContext";

// Utils
import {FormattedMessage} from "react-intl";
import {WmsItemsStatus} from "utils/WmsItemsStatus";
import {BpCheckedIcon, BpIcon} from "../../../../../../components/WMS/AccordionShipment/checkboxIcons";
import Checkbox from "@mui/material/Checkbox";
import {greyishBlue50} from "../../../../../../assets/jss/main";
import {MissionContext} from "../../../context/MissionContext";
import Badge from "../../../../../../components/Badge";
import store from "../../../../../../store";
import FormattedNumberWithCurrency
    from "../../../../../../components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

function PickingOrInTrolleyItemList({retailerItems, wmsItems, onItemClick = (wmsItem) => {}}) {
    const {groupWmsItemsBySku, currentOrganization} = React.useContext(WMSContext);
    const {putBatchItemsInTrolley, refreshMission, loading, setLoading} = useContext(MissionContext)

    const [itemList, setItemList] = useState([])
    const [displayFooter, setDisplayFooter] = useState(false)
    const [checkedItemCount, setCheckedItemCount] = useState(null)
    const [totalEligibleCount, setTotalEligibleCount] = useState(0)

    function getInTrolleyTotalBySku(sku) {
        return retailerItems.filter(item => item.lineItem.variationSku === sku && item.status === WmsItemsStatus.IN_TROLLEY).length;
    }

    function getTotalProductBySku(sku) {
        return retailerItems.filter(item => item.lineItem.variationSku === sku).length;
    }

    function handleSelectedItem(item) {
        let tempItemList = [...itemList]

        for (let tempItemListElement of tempItemList) {
            if (tempItemListElement.id === item.id) {
                if (tempItemListElement.checked) {
                    tempItemListElement.checked = false
                } else {
                    tempItemListElement.checked = true
                }
            }
        }

        setItemList(tempItemList)
    }

    function handleValidateAll() {
        const eligibleSKUs = itemList
            .filter(item => {
                if (!item.lineItem.variationSku) return false
                const inTrolleyTotal = getInTrolleyTotalBySku(item.lineItem.variationSku)
                const total = getTotalProductBySku(item.lineItem.variationSku)
                return inTrolleyTotal <= 0 && inTrolleyTotal !== total
            })
            .map(item => item.lineItem.variationSku)

        setLoading(true)
        putBatchItemsInTrolley(eligibleSKUs).then(() => {
            refreshMission()
        })
            .catch(() => {
                setLoading(true)
            })
    }

    function handleManualValidation() {
        const checkedItems = itemList.filter((item) => true === item.checked)

        const toBePatchItemsSKU = checkedItems.map((item) => {
            return item.lineItem.variationSku
        })

        setLoading(true)

        putBatchItemsInTrolley(toBePatchItemsSKU).then(() => {
            refreshMission()
        }).catch(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (wmsItems) {
            setItemList(groupWmsItemsBySku(wmsItems))
        }
    }, [wmsItems]);

    useEffect(() => {
        const count = itemList.reduce((acc, item) => {
            if (!item.lineItem.variationSku) return acc
            const inTrolleyTotal = getInTrolleyTotalBySku(item.lineItem.variationSku)
            const total = retailerItems.filter(
                ri => ri.lineItem.variationSku === item.lineItem.variationSku && ri.status !== WmsItemsStatus.CANCELED
            ).length
            if (inTrolleyTotal <= 0 && inTrolleyTotal !== total) {
                return acc + total
            }
            return acc
        }, 0)
        setTotalEligibleCount(count)
    }, [itemList])

    useEffect(() => {
        if (0 < itemList.length) {
            const checkedItems = itemList.filter((item) => true === item.checked)

            let checkedItemsCount = 0
            for (const checkedItemElement of checkedItems) {
                checkedItemsCount += checkedItemElement.count
            }

            setCheckedItemCount(checkedItemsCount)
            setDisplayFooter(0 < checkedItemsCount)
        }
    }, [itemList])

    const displayValidateAllFooter =
        currentOrganization.wmsPickingManualValidation &&
        totalEligibleCount > 0 &&
        !displayFooter

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            <div style={{flex: 1, overflow: 'auto', minHeight: 0}}>
                <Grid container direction={'column'}>
                    {itemList && itemList.map((item, index) => {
                        const totalBySku = getTotalProductBySku(item.lineItem.variationSku);
                        const inTrolleyTotalBySku = getInTrolleyTotalBySku(item.lineItem.variationSku);
                        let isEligibleToManualValidation = false

                        if (item.lineItem.variationSku) {
                            isEligibleToManualValidation = true
                        }

                        return (
                            <MobileItem onClick={() => onItemClick(item)} key={index}>
                                <MobileItem.LeftSide
                                    title={item.lineItem.name}
                                    subtitle={<LineItemOptionList options={item.lineItem?.options}/>}
                                    underTitle={
                                        <Grid
                                            container
                                            direction={'column'}
                                            gap={'8px'}
                                            sx={{width: '100%'}}
                                        >
                                            <WmsItemCodes wmsItem={item}/>
                                            <WmsItemPlaceList wmsItem={item}/>
                                        </Grid>
                                    }
                                >
                                    <ThumbnailAndNotification
                                        link={item.lineItem.pictures?.[0]}
                                        alt={item.lineItem.name}
                                        selected={!item.checked ? null : true}
                                        validated={inTrolleyTotalBySku > 0 && (inTrolleyTotalBySku === totalBySku)}
                                    />
                                </MobileItem.LeftSide>
                                <MobileItem.RightSide maxHeight>
                                    <Grid container direction={'column'} alignItems={"end"}
                                          justifyContent={'space-between'} sx={{height: '100%'}}>
                                        {currentOrganization.wmsPickingManualValidation && inTrolleyTotalBySku <= 0 && (inTrolleyTotalBySku !== totalBySku) && isEligibleToManualValidation && (
                                            <Checkbox
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleSelectedItem(item)
                                                }}
                                                checked={item.checked}
                                                icon={<BpIcon/>}
                                                checkedIcon={<BpCheckedIcon/>}
                                                sx={{padding: 0}}
                                                disabled={loading}
                                            />
                                        )}
                                        <Grid container gap={'8px'}>
                                            <VariationCount
                                                count={!item.checked ? inTrolleyTotalBySku : totalBySku}
                                                maxCount={!item.checked ? totalBySku : null}
                                                maxAchieveColor={'oceanBlue'}
                                                forcedColor={item.checked}
                                            />
                                            {WmsItemsStatus.PICKING === item.status && (
                                                <Badge
                                                    rounded
                                                    isBold={false}
                                                    color={'online'}
                                                    size={'large'}
                                                >
                                                    <FormattedNumberWithCurrency value={item.totalPrice} currency={store.getState().currentOrganization?.retrieved?.currency} />
                                                </Badge>
                                            )}
                                        </Grid>
                                    </Grid>

                                </MobileItem.RightSide>
                            </MobileItem>
                        )
                    })}
                </Grid>
            </div>

            {displayFooter && (
                <footer style={{
                    width: '100%',
                    flexShrink: 0,
                }}>
                    <Card sx={{
                        height: 'fit-content',
                        boxShadow: 'none',
                        borderTop: `1px solid ${greyishBlue50}`,
                        borderBottom: `1px solid ${greyishBlue50}`,
                        borderRadius: 0,
                        width: '100%',
                    }}>
                        <CardContent sx={{
                            padding: '16px',
                            flexShrink: 0,
                            backgroundColor: 'white',
                            '&:last-child': {
                                paddingBottom: '16px',
                            },
                        }}>
                            <CustomButton
                                fullWidth
                                onClick={() => handleManualValidation()}
                                disabled={loading}
                            >
                                <FormattedMessage id={"wms.myPickingMissions.product.manualSelection.buttonLabel"}
                                                  values={{itemCount: checkedItemCount ?? 0}}/>
                            </CustomButton>
                        </CardContent>
                    </Card>
                </footer>
            )}

            {displayValidateAllFooter && (
                <footer style={{
                    width: '100%',
                    flexShrink: 0,
                }}>
                    <Card sx={{
                        height: 'fit-content',
                        boxShadow: 'none',
                        borderTop: `1px solid ${greyishBlue50}`,
                        borderBottom: `1px solid ${greyishBlue50}`,
                        borderRadius: 0,
                        width: '100%',
                    }}>
                        <CardContent sx={{
                            padding: '16px',
                            flexShrink: 0,
                            backgroundColor: 'white',
                            '&:last-child': {
                                paddingBottom: '16px',
                            },
                        }}>
                            <CustomButton
                                fullWidth
                                onClick={() => handleValidateAll()}
                                disabled={loading}
                            >
                                <FormattedMessage
                                    id={"wms.myPickingMissions.product.validateAll.buttonLabel"}
                                    values={{itemCount: totalEligibleCount}}
                                />
                            </CustomButton>
                        </CardContent>
                    </Card>
                </footer>
            )}
        </div>
    )
}

export default PickingOrInTrolleyItemList;
